import HeaderLine from "../font/headerline";
import Header from "../font/header1";
import Header2 from "../font/header2";
import Card from "../layout/card";
import Threebox from "../layout/threebox";
import CircleIcon from "../circleIcon/circleIcon";
import H4 from "../font/H4";
import doorman from "../../img/doorman.png";
import maintenance from "../../img/maintenance.png";
import dashboard from "../../img/dashboard.png"

const WhatWeDo = () => {
    return (
        <div className='flex flex-col justify-center pt-16 lg:pt-24 lg:p-10 bg-lightblue'>
            <div className='flex flex-row'>
                <HeaderLine />
                <div className='flex flex-col place-items-center flex-1 lg:flex-none w-full lg:w-auto px-4'>
                    <Header>What we do</Header>
                </div>
                <HeaderLine />
            </div>
            <Header2>Transform your house into a highly manageable asset with a true Home Operating System</Header2>
            <Threebox>
                <Card>
                    <CircleIcon icon={doorman} />
                    <H4> Smart Triage Concierge </H4>
                    <p>Let our intelligence engine act as your digital property manager. When an issue arises, our AI diagnoses urgency, references manuals, and automatically categorizes tasks into routine upkeep or urgent repair.</p>
                </Card>
                <Card>
                    <CircleIcon icon={maintenance} />
                    <H4> Proactive Health Tracking </H4>
                    <p>Move beyond reactive repairs. We constantly calculate your Home Health Score based on your home's unique data, helping you catch component failures before they hit your wallet.</p>
                </Card>
                <Card>
                    <CircleIcon icon={dashboard} />
                    <H4> Total System of Record </H4>
                    <p>A single, seamless dashboard that aggregates all property records. Maintain your Digital Asset Logbook with manufacturer data, warranties, past contractor quotes, and DIY expense receipts.</p>
                </Card>
            </Threebox>
        </div>
    )
}

export default WhatWeDo